import { palette } from 'app_previous/styles/colors';
import styled, { css } from 'styled-components';

export const ResourceCenterMobileMenuContainer = styled.div`
  height: 100vh;
  width: calc(100vw - 4rem);
  position: fixed;
  z-index: 110; // HEADER TOP BAR IS 100
  left: 0px;
  top: 0px;
  transition: transform ease-in-out 0.3s;
  background-color: ${palette.chineseBlack};
  overflow: auto;
`;

export const ResouceCenterMobileMenuOverlay = styled.div<{ opened: boolean }>`
  z-index: 109;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(23, 30, 40, 0.5);
  transition: opacity ease-in-out 0.3s;

  ${({ opened }) =>
    opened
      ? css`
          opacity: 1;
          pointer-events: initial;
          background-color: ${palette.darkGray};
        `
      : css`
          opacity: 0;
          pointer-events: none;
        `}
`;

export const ResourceCenterMobileMenuLinkOverflow = styled.div`
  transition: max-height ease-in-out 0.3s;
  width: 100%;
  box-sizing: border-box;
  grid-column: 1 / 4;
  overflow: hidden;
  position: relative;
  &:before {
    content: '';
    top: 0px;
    left: 0px;
    position: absolute;
    width: 100%;
    border-top: solid 1px #e5e8ee;
    z-index: 2;
  }

  & > div {
    background-color: ${palette.darkGray};
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
`;

export const ResourceCenterMobileMenuLink = styled.div<{ extendable?: boolean; active?: boolean }>`
  width: 100%;
  display: grid;
  box-sizing: border-box;
  grid-template-columns: auto 1fr 56px;
  background-color: ${({ active }) => (active ? palette.darkGray : palette.chineseBlack)};

  a {
    min-height: 43px;
    padding: 9px;
    color: ${palette.white};
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.3;
    text-decoration: none;
    display: flex;
    align-self: center;
    box-sizing: border-box;
    transition: background-color ease-in-out 0.3s;
  }

  & > span {
    align-self: center;
  }
`;

export const ResourceCenterMobileMenuPost = styled.div`
  position: relative;
  display: grid;
`;

export const ResourceCenterMobileCloseButton = styled.div`
  position: absolute;
  top: 1rem;
  right: 1rem;
  z-index: 1;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: ${palette.lightSierraRain};
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    text-align: center;
    line-height: 0px;
  }
`;
